import { object } from 'superstruct';
import { userString } from '@arc/shared/util-superstruct';
export const AddArcRoleDto = object({
  name: userString('validations:Required')
});